<template>
  <div style="text-align: center" v-if="index < 8">
    <ejs-button
      cssClass="e-primary"
      v-if="previousBtn"
      v-on:click.native="onPrevTab"
    >
      <font-awesome-icon :icon="['fas', 'file']" style="display: inline" />
      Previous
    </ejs-button>
    <ejs-button cssClass="e-info" v-on:click.native="onSaveDraft">
      <font-awesome-icon :icon="['fas', 'file']" style="display: inline" />
      Save as Draft
    </ejs-button>
    <ejs-button
      v-if="showNextButton"
      data-test-footer-buttons="nxt"
      cssClass="e-primary"
      v-on:click.native="onNextTab"
    >
      <font-awesome-icon :icon="['fas', 'file']" style="display: inline" />
      Next
    </ejs-button>
  </div>
  <div style="text-align: center; padding: 10px" v-else>
    <ejs-button
      cssClass="e-danger"
      :disabled="disabled"
      @click.native="$emit('submit')"
    >
      <font-awesome-icon :icon="['fas', 'file-alt']" style="display: inline" />
      Submit & Check out
    </ejs-button>
  </div>
</template>

<script>
export default {
  props: {
    previousBtn: {
      type: Boolean,
      default: true,
    },
    showNextButton: {
      type: Boolean,
      default: true,
    },
    disabled: Boolean,
    index: Number,
  },

  methods: {
    onNextTab() {
      this.navigate(this.index + 1);
    },

    onPrevTab() {
      this.navigate(this.index - 1);
    },

    navigate(newIndex) {
      const currentIndex = this.index;
      this.selectTab(newIndex);
      this.$emit('savePermit', {
        currentIndex,
        newIndex,
        showSaveNotification: false,
      });
    },

    selectTab(index) {
      const tabObj = document.getElementById('permitapplication_tab');
      const tabInstance = tabObj.ej2_instances[0];
      tabInstance.enableTab(index, true);
      tabInstance.select(index);
    },

    onSaveDraft() {
      const currentIndex = this.index;
      this.$emit('savePermit', { currentIndex, showSaveNotification: true });
    },
  },
};
</script>
